import React, {memo} from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import {makeStyles} from '@material-ui/core/styles'


const useStylesSpinner = makeStyles(() => {
    return {
        root: {
            '& .MuiCircularProgress-colorPrimary': {
                color: 'rgba(255, 255, 255, 0.91)',
            },
        },
    }
})

const Spinner = ({isFullScreen = true}) => {
    const classes = useStylesSpinner()

    if (!isFullScreen) return <CircularProgress/>
    return (
        <div className="spinner_container">
            <div className={classes.root}>
                <CircularProgress />
            </div>

        </div>
    )
}

export default memo(Spinner)
